<template>
    <div v-show="visible">
        <el-dialog title="新增时间" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">          
                <el-form-item prop="startTime" label="开始时间">
                    <el-time-select
                        placeholder="开始时间"
                        v-model="form.startTime"
                        :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                    </el-time-select>
                </el-form-item>
                <el-form-item prop="endTime" label="结束时间">
                    <el-time-select
                        placeholder="结束时间"
                        v-model="form.endTime"
                        :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:59'
                        }">
                    </el-time-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                isAuto:false,
                transferVisible:false,
                props: { checkStrictly: true},
                form:{
                    startTime:"",
                    endTime:""
                },
                rules: {
                    startTime: [
                        { required: true, message: '请选择开始时间', trigger: 'blur' }
                    ],
                    endTime: [
                        { required: true, message: '请选择结束时间', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        let data = {
                            startTime:this.form.startTime,
                            endTime:this.form.endTime
                        };
                        this.$parent.addTime(data);
                        this.visible=false;
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/gate/AddTime.vue